<template>
  <div>
    <public-header title="电池商品"></public-header>
      <ak-model-filter-card model="batteryAgent" @search="search" @reset="reset" />
      <!-- <tk-flex wrap between >
        <tk-flex gutter="16px" wrap >
          <Select placeholder="系列" showSearch :list="serseList" :value.sync="serse" :styleModule="{width: '100px'}" ></Select>
          <Select placeholder="电压" showSearch :list="voltageList" :value.sync="voltage" :styleModule="{width: '100px'}" ></Select>
          <Select placeholder="容量" showSearch :list="capacityList" :value.sync="capacity" :styleModule="{width: '100px'}" ></Select>
          <ak-type-input class="hide-label" v-model="name" :field="field" style="minWidth: 100px" />
        </tk-flex>
        <a-button type="primary" @click="showCreate = true" >
          新增商品
        </a-button>
      </tk-flex> -->
    <a-card>
      <ak-model-card class="hide-padding" model="batteryAgent" :filters="filters" ref="management" tableSize="small" />
    </a-card>
    <!-- 新增商品弹框 -->
    <Basic :visible.sync="showCreate" :vm="this" ></Basic>
  </div>
</template>

<script>

import publicHeader from '../../components/publicHeader.vue'
// import Select from '../components/select.vue'
import Basic from './component/basic.vue'

export default {
  components: {
    publicHeader,
    // Select,
    Basic
  },
  data () {
    return {
      filters: {
        isDelete: { $ne: true }
      },
      serse: '', // 系列
      serseList: [],
      voltage: '', // 电压
      voltageList: [],
      capacity: '', // 容量
      capacityList: [],
      name: '',
      field: {
        name: 'name', // 表单字段名，必填，用来分辨不同的input
        note: '名称', // 表单显示的名称，如果为空则显示表单name
        type: 'Pointer', // 表单输入类型，所有数据模型类型都可以使用，默认为String
        targetClass: 'commodity', // 当数据类型为Pointer时必填，指定查询对象
        searchKey: ['name'], // 仅在 Pointer类型下有效，根据输入内容搜索的字段名
        listWhere: (where) => {
          where.isDelete = {
            $ne: true
          }
        }, // 设置可选项的查询条件
        placeholder: '搜索', // 仅在 String type下有效
        disabled: false // 禁用表单
      },
      showCreate: false
    }
  },
  watch: {
    page (val) {
      this.$router.replace({
        path: this.$route.path,
        query: Object.assign({}, this.$route.query, { page: this.page })
      })
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      try {
        await this.getSeries() // 获取系列
        await this.getVoltage() // 获取电压
        await this.getCapacity() // 获取容量
      } catch (error) {

      }
    },
    async getSeries () {
      let { data: res } = await this.$tkParse.get('/classes/series', { params: { limit: 1000, where: { isDelete: { $ne: true } } } })
      this.serseList = res.results
    },
    async getVoltage () {
      let { data: res } = await this.$tkParse.get('/classes/voltage', { params: { limit: 1000, where: { isDelete: { $ne: true } } } })
      this.voltageList = res.results
    },
    async getCapacity () {
      let { data: res } = await this.$tkParse.get('/classes/capacity', { params: { limit: 1000, where: { isDelete: { $ne: true } } } })
      this.capacityList = res.results
    },
    search (filters) {
      console.log(1)
      console.log('🚀 ~ file: battery.vue:99 ~ search ~ filters:', filters)
      // filters是组件自动生成的where搜索参数
      this.page = 1
      this.filters = { isDelete: { $ne: true } }
      this.filters = { ...this.filters, ...filters }
    },
    reset () {
      this.page = 1
      this.filters = { isDelete: { $ne: true } }
    }
  }
}
</script>

<style>

</style>
